/**
Project: Voice Panel (c)
Title: Setup Item 
Description: Component to show the progression of the setup
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React from "react";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";
import {
  Loader,
  Text,
  Button,
  AcceptIcon,
  CloseIcon,
} from "@fluentui/react-northstar";

const SetupItem = ({ title, status }) => {
  const showProgress = (status) => {
    if (status === VoiceAdminConstants.VOICE_SETUP.SETUP_STATUS.IN_PROGRESS) {
      return (
        <Loader
          size="medium"
          className="vpa-voice-setup-item-icon-inprogress"
        />
      );
    } else if (
      status === VoiceAdminConstants.VOICE_SETUP.SETUP_STATUS.SUCCESS
    ) {
      return (
        <Button
          disabled
          size="medium"
          circular
          content={<AcceptIcon size="large" />}
          className="vpa-voice-setup-item-icon-success"
        />
      );
    } else if (
      status === VoiceAdminConstants.VOICE_SETUP.SETUP_STATUS.FAILURE
    ) {
      return (
        <Button
          disabled
          size="medium"
          circular
          content={<CloseIcon size="large" />}
          className="vpa-voice-setup-item-icon-failure"
        />
      );
    } else {
      return (
        <Button
          disabled
          size="medium"
          circular
          className="vpa-voice-setup-item-icon-notstarted"
        />
      );
    }
  };
  return (
    <div className="vpa-voice-setup-item-wrapper">
      <div className="vpa-voice-setup-item-icon-wrapper">
        {showProgress(status)}
      </div>
      <div className="m-t-10">
        <Text className="page-text">{title}</Text>
      </div>
    </div>
  );
};

export default SetupItem;
